export default __webpack_public_path__ + "static/media/MenuVertical.2fa12f95.svg";